import styled from "styled-components";

export const AddCategoryFormContainer = styled.form`
  .ant-upload-select, .ant-upload-list-item-done {
    width: 100% !important;
  }
section {
  margin: 15px 0;
  #upload-zone {
    height: 67px;
    font-size: 0.833em;
    p {
      margin-bottom: 5px;
    }
  }
}
  .category-upload-footer {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }
  .category-delete-cover {
    background: none;
    width: 130px;
    height: 39px;
    padding: 0 5px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: ${({ theme }) => theme.colors.primary};
    border: 0;
    font-size: 1em;
    cursor: pointer;
    transition: background 0.3s ease-in-out;

    &:hover {
      background-color: ${({ theme }) => theme.colors.softGray};
    }

    &:disabled {
      color: ${({ theme }) => theme.colors.darkGray};
      cursor: not-allowed;

      svg {
        fill: ${({ theme }) => theme.colors.darkGray};
      }
    }

    svg {
      background: none;
      fill: ${({ theme }) => theme.colors.primary};
      margin-right: 8px;
    }
  }

  footer {
    display: flex;
    justify-content: flex-end;
    margin-top: 15px;
    width: 100%;
    gap: 15px;
  }
`;

export const CategoryCoverImage = styled.div<{ coverImage?: string }>`
  width: 100%;
  height: 348.75px;
  background-color: ${({ theme }) => theme.colors.softGray};
  background-image: url(${({ coverImage }) => coverImage});
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;

  span {
    background: none;
    font-size: 0.8em;
    color: ${({ theme }) => theme.colors.darkGray};
  }
`;

export const AddDivider = styled.div`
  margin: 15px 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.lightGray};
`;